import moment from "moment";

export const getParams = (search: string) => {
        let params: {[key: string]: string | null} = {};
        if (search) {
            const match = search.match(/(\?|&)[a-zA-Z0-9]+(=)[a-zA-Z0-9._-]+/g);
            if (match) {
                match.map((x: string) => x.substring(1, x.length).split('=')).forEach(x => {
                    params[x[0]] = x[1] === 'null' ? null : x[1];
                });
            }
        }
        return params;
    }

export const fromHexString = (hexString: string) =>
  new Uint8Array((hexString.match(/.{1,2}/g) || []).map((byte: string) => parseInt(byte, 16)));

export const toHexString = (bytes: Uint8Array) =>
  bytes.reduce((str, byte) => str + byte.toString(16).padStart(2, '0'), '');

export const base64ToByteArray = (base64: string) => {
  var binaryString = atob(base64);
  var bytes = new Uint8Array(binaryString.length);
  for (var i = 0; i < binaryString.length; i++) {
      bytes[i] = binaryString.charCodeAt(i);
  }
  return bytes;
}

export const hexToBase64 = (hex: string) => {
  return btoa(hex.match(/\w{2}/g)!.map(function(a) {
      return String.fromCharCode(parseInt(a, 16));
  }).join(""));
}

export const isMobileDevice = () => {
  let check = false;
  // eslint-disable-next-line no-useless-escape
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  return check;
};

export const handleTextInputNumberChange = (oldValue: string, newValue: string) => {
  const trimmed = newValue.trim();

  if (!trimmed) {
    return '';
  }
  return isNaN(Number(trimmed)) ? oldValue : trimmed;
}

export const capitalizeWords = (value: string) =>
  value.replace(/(^|\s)(\p{L})/gu, (match) => match.toUpperCase());

export function roundNumber(value: number, roundTo: number): number {
  return Math.round(value * Math.pow(10, roundTo)) / Math.pow(10, roundTo);
}

const TAX_STRING_BEFORE = "22%";
const TAX_STRING_AFTER = "24%";
const TAX_MULTIPLIER_BEFORE = 1.22;
const TAX_MULTIPLIER_AFTER = 1.24;
const TAX_ADJUSTMENT_DATE = moment({year: 2025, month: 6, day: 1});

const isDateEqualOrPastTaxAdjustmentDate = (date: moment.Moment) => {
  return date.isSameOrAfter(TAX_ADJUSTMENT_DATE);
}

export function getTax(date: moment.Moment){
  if(isDateEqualOrPastTaxAdjustmentDate(date)) return TAX_MULTIPLIER_AFTER;
  return TAX_MULTIPLIER_BEFORE;
}

export function getTaxString(){
  if(isDateEqualOrPastTaxAdjustmentDate(moment(new Date()))) return TAX_STRING_AFTER;
  return TAX_STRING_BEFORE;
}

export function getPriceWithoutVAT(priceWithVAT: number, date: moment.Moment, roundTo = 3): number {
  if (!priceWithVAT) {
    return priceWithVAT;
  }

  return roundNumber(priceWithVAT / getTax(date), roundTo);
}

export function getPriceWithVAT(priceWithoutVAT: number, roundTo = 3, date: moment.Moment): number {
  if (!priceWithoutVAT) {
    return priceWithoutVAT;
  }

  return roundNumber(priceWithoutVAT * getTax(date), roundTo);
}

export const getVatAmount = (sum: number, date: moment.Moment, roundTo = 3) => {
  const withoutVat = getPriceWithoutVAT(sum, date);
  const amount = Number(sum) - Number(withoutVat);
  return roundNumber(amount, roundTo);
};

export function isMobile() {
  const userAgent = window.navigator.userAgent.toLowerCase();
  const ios = /iphone|ipod|ipad/.test(userAgent);
  const android = /android/.test(userAgent);
  
  return ios || android ? 'true' : 'false';
}

export function redirectToLogin() {
  window.location.replace(`${process.env.REACT_APP_PRIVATE_URL}/login?logout=true`);
}

export const normalizeCommaSeparatedEmail = (email?: string) => {
  if(!email) return email;

  return email.split(",").map(email => email.trim()).join(",");
}

export type FormControlElement = HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement;

export const onNumberChange = (e: React.ChangeEvent<FormControlElement>): number | undefined => {
    const value = e.target.value;
    const parsedValue = parseFloat(value);

    if (value === "" || Number.isNaN(parsedValue)) return undefined;
    return parsedValue;
};